export default __webpack_public_path__ + "static/media/japango-screenshot-06.b33a2251.png";